import React, { useMemo } from "react";
import { Table } from "react-bootstrap";
import EditLocationRadioButtons from "../editlocationdetails/EditLocationRadioButtons";
import LocationServices from "../locationdetails/LocationServices";
import ApproveDenyAllToggle from "./ApproveDenyAllToggle";

export default function PendingServicesEdits(props) {
  const pendingEdits = useMemo(() => { return props.pendingEdits }, [props]);

  function handleApproveDeny(target){
    props.handleApproveDeny(target, "services");
  }

  function handleReviewedAllCheck(checked){
    props.handleReviewedAllCheck(checked, "services");
  }
  
  return (
    <div className="edit-details-body">
      <div className="edit-details-title">
        Original Services
        <div className="original-data-body services-edits"> 
          {<LocationServices services={props.originalServices}></LocationServices>}
        </div>
      </div>     
      <div className="pending-edits-body-margin">
        {pendingEdits?.length > 0 ? (
            <>
            <div className="edit-details-title">Services Edits</div>
            <ApproveDenyAllToggle 
              handleApproveDenyAll={handleApproveDeny} 
              reviewedAll={props.reviewedAll.reviewedAll} 
              approveDenyAll={props.reviewedAll.approvedAll}
              handleReviewedAllCheck={handleReviewedAllCheck}
            />
            <div className="location-pending-edits-table">
                <Table className="floating-table edits-table-content-align-top">
                    <thead>
                        <tr>
                          <th className="edits-table-th-first">Editor Username</th>                           
                            <th>Time Stamp ({props.userTimeZone})</th>
                            <th style={{ width: "200px"}}>Services</th>                      
                            <th style={{ textAlign: "center"}}>Review Edits</th>
                        </tr>
                    </thead>               
                    <tbody>
                            {pendingEdits.map((item, index) =>
                            <tr key={item.editId}>
                                <td className="edits-table-td-first">{item.editAddedBy}</td>                                
                                <td>{props.convertTimeToLocal(item.editAddedDate)}</td>
                                <td>
                                  <LocationServices services={item}></LocationServices>
                                </td>
                                <td style={{ textAlign: "center"}}>
                                  <EditLocationRadioButtons 
                                      radioName={item.editId}
                                      radioIndex={index}
                                      radioOptions={props.toggleOptions}
                                      radioChecked={item.approved !== undefined ? item.approved : null}
                                      defaultValue={null}
                                      useToggle={true}
                                      onRadioChange={handleApproveDeny}
                                  />
                                </td>
                            </tr>
                        )}
                    </tbody>
                    </Table>
                </div>
            </>
        ) :
        (
            <div className="edit-details-title">
                *** No Edits to review ***
            </div>
        )}       
      </div>
    </div>
  );
}